import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { usePlantData } from '../../../components/data/PlantData';
import SidebarPageLayout from '../../../components/layout/SidebarPageLayout';
import Marquee from '../../../components/layout/Marquee';
import DiagnosticPowerBlocks from '../../../components/layout/DiagnosticPowerBlocks';
import ChartTooltip from '../../../components/layout/ChartTooltip';
import { toSlug } from '../../../util/strings';
import Breadcrumbs from '../../../components/layout/Breadcrumbs';

function ACBlock() {
  const { plant: gemini } = usePlantData();
  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, content: '' });
  const portfolioName = toSlug(gemini.plant_name) ?? "";

  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub | Gemini / Diagnostics / ACBlock";
  }, []);

  return (
    <SidebarPageLayout>
      <div className="content p-5">
        <ChartTooltip tooltip={tooltip} transition={false} />
        <Marquee />
        <h1 className="mt-3 mb-0"><Link to={`${gemini.dashboard}`}><strong>{gemini.plant_name}</strong></Link> : {gemini.config} ({gemini.location})</h1>
        <Breadcrumbs labels={{ portfolioName: gemini.plant_name }} />
        <DiagnosticPowerBlocks
          portfolioName={portfolioName}
          onTooltip={setTooltip}
          timeZone={gemini.timezone}
        />
      </div>
    </SidebarPageLayout>
  );
}

export default ACBlock;
